var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Box, HStack, forwardRef, useRadio, useRadioGroup, useStyleConfig, } from "@chakra-ui/react";
import { RadioOutlineIcon, RadioSelectedIcon } from "../icons";
export const Radio = forwardRef((props) => {
    const { getInputProps, getCheckboxProps } = useRadio(props);
    const input = getInputProps();
    const _a = getCheckboxProps(), { onMouseLeave, onMouseEnter } = _a, checkbox = __rest(_a, ["onMouseLeave", "onMouseEnter"]);
    const styles = useStyleConfig("BlueprintRadio");
    const isChecked = input.checked;
    return (React.createElement(Box, { as: "label" },
        React.createElement("input", Object.assign({}, input)),
        React.createElement(Box, { as: "span", sx: {
                display: "flex",
                alignItems: "center",
            } },
            React.createElement(Box, Object.assign({ as: isChecked ? RadioSelectedIcon : RadioOutlineIcon }, checkbox, { __css: styles })),
            props.children)));
});
export const RadioGroup = forwardRef((_a) => {
    var { stackProps } = _a, rest = __rest(_a, ["stackProps"]);
    const { getRootProps, getRadioProps } = useRadioGroup(rest);
    const childrenWithProps = React.Children.map(rest.children, (child) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, getRadioProps({ value: child.props.value }));
        }
        return child;
    });
    const group = getRootProps();
    return (React.createElement(HStack, Object.assign({}, group, stackProps), childrenWithProps));
});
